import React from 'react';

import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import OurProcess from './components/OurProcess';
import AdaptToYourNeeds from './components/AdaptToYourNeeds';
import ContactForm from './components/Contact';
import Footer from './components/Footer';

const Home = () => {
  return (
    <div className="w-full h-full overflow-x-hidden">
      <Header />
      <Hero />
      <Features />
      <AdaptToYourNeeds />
      <OurProcess />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
